import styled from '@emotion/styled'

export const Dot = styled.span`
  display: inline-block;
  width: 4px;
  height: 4px;
  background: currentColor;
  border-radius: 50%;
`
